import { CloudSensorStatus as ApiSensorStatus } from '@rtkwlf/rendall';

export enum HealthStatus {
  New = 'new',
  Healthy = 'healthy',
  InProgress = 'inProgress',
  Shipping = 'shipping',
  NeedsAttention = 'needsAttention',
  Unhealthy = 'unhealthy',
  Other = 'other',
  NeedsInvestigation = 'needsInvestigation',
  Disconnected = 'disconnected',
  Degraded = 'degraded',
}

export enum TelemetryEntityType {
  Agent = 'agents',
  Sensor = 'sensors',
  Scanner = 'scanners',
  CloudSensor = 'cloudSensors',
  ScanSchedules = 'scanSchedules',
}

export enum TabKey {
  ScannerInformation = 'scannerInformation',
  ScannerDetails = 'scannerDetails',
  HostDnsServers = 'hostDnsServers',
  ScanExclusion = 'scanExclusion',
  ScanningQueue = 'scanningQueue',
  ScanningSchedule = 'scanningSchedule',
  CredentialedScanning = 'credentialedScanning',
  ScannerUpgradeSchedule = 'scannerUpgradeSchedule',
  NetworkConfiguration = 'networkConfiguration',
  ShippingDetails = 'shippingDetails',
}

export const CloudSensorStatus = {
  ...ApiSensorStatus,
  Degraded: 'degraded',
};

export enum WazuhStatus {
  Success = 'success',
  ConnectionFailure = 'failure',
  WazuhNotInstalled = 'not-installed',
  TcppingFailure = 'tcpping-failure',
  TcppingReconnectFailure = 'tcpping-reconnect-failure',
  TcppingSuccess = 'tcpping-success',
}

export enum TelemetryCapabilities {
  SscManageApplianceWrite = 'ssc_manage_appliance_write',
}
